import { render, staticRenderFns } from "./TabPutaway.vue?vue&type=template&id=53d8b618"
import script from "./TabPutaway.vue?vue&type=script&lang=js"
export * from "./TabPutaway.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports